import Vue from "vue";
import VueMq from "vue-mq";

import "material-design-icons-iconfont/dist/material-design-icons.css";

window.Vue = Vue;
Vue.config.silent = true;

Vue.use(VueMq, {
  breakpoints: {
    mobile: 375,
    phablet: 768,
    tablet: 1024,
    desktop: 1440,
    desktopHD: Infinity
  }
});

import NsProductAppService from "./services/NsProductAppService";
import NsProductUserService from "./services/NsProductUserService";
import NsProductFeatureFlagsService from "./services/NsProductFeatureFlagsService";
import NsProductDataService from "./services/NsProductDataService";

import NsProductMixin from "./mixins/NsProductMixin.js";

import NsPayPalPayLater from "./components/NsPayPalPayLater.vue";
import NsProductCardBase from "./components/NsProductCardBase.vue";
import NsProductCard from "./components/NsProductCard.vue";
import NsProductDetailBase from "./components/NsProductDetailBase.vue";
import NsProductDetail from "./components/NsProductDetail.vue";
import NsProductCarousel from "./components/NsProductCarousel.vue";
import NsProductList from "./components/NsProductList.vue";
import NsProductListSortable from "./components/NsProductListSortable.vue";
import NsProductLine from "./components/NsProductLine.vue";
import NsProductOffer from "./components/NsProductOffer.vue";
import NsProductQuantitySelector from "./components/NsProductQuantitySelector.vue";

export {
  // Services
  NsProductAppService,
  NsProductUserService,
  NsProductFeatureFlagsService,
  NsProductDataService,
  // Mixins
  NsProductMixin,
  // Components
  NsPayPalPayLater,
  NsProductCardBase,
  NsProductCard,
  NsProductDetailBase,
  NsProductDetail,
  NsProductCarousel,
  NsProductList,
  NsProductListSortable,
  NsProductLine,
  NsProductOffer,
  NsProductQuantitySelector
};
